var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLandmarkCluster(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 60,
    viewBox: "0 0 56 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "cluster_landmark_icon",
    width: "126.1%",
    height: "119.9%",
    x: "-13%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 1.6
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.188,
    fillRule: "nonzero",
    d: "M31.276 51.248c-9.484-.807-16.949-9.453-16.949-20 0-11.08 8.238-20.062 18.4-20.062 10.162 0 18.4 8.982 18.4 20.062 0 9.41-5.942 17.306-13.958 19.473-.719.33-1.259.676-1.62 1.038-.561.564-1.166 1.643-1.814 3.24-.648-1.597-1.252-2.676-1.814-3.24a3.95 3.95 0 0 0-.645-.511zm2.31 8.084c-.883 0-1.6-.718-1.6-1.605 0-.886.717-1.605 1.6-1.605.885 0 1.6.719 1.6 1.605 0 .887-.715 1.605-1.6 1.605z",
    filter: "url(#cluster_landmark_icon)",
    transform: "rotate(25 32.727 35.259)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6700C2",
    fillRule: "nonzero",
    d: "M18.504 47.514C7.898 45.02 0 35.473 0 24.074 0 10.778 10.745 0 24 0s24 10.778 24 24.074c0 11.399-7.898 20.947-18.504 23.44-1.427.555-2.453 1.146-3.077 1.772-.749.751-1.555 2.19-2.419 4.319-.864-2.128-1.67-3.568-2.419-4.319-.624-.626-1.65-1.217-3.077-1.772zM24 57.778c-.884 0-1.6-.719-1.6-1.605 0-.887.716-1.605 1.6-1.605.884 0 1.6.718 1.6 1.605 0 .886-.716 1.605-1.6 1.605z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M24 25.679a2.402 2.402 0 0 0-2.4 2.407c0 1.806 2.4 4.471 2.4 4.471s2.4-2.665 2.4-4.47a2.402 2.402 0 0 0-2.4-2.408zm-.857 2.407c0-.474.384-.86.857-.86a.859.859 0 0 1 0 1.72.859.859 0 0 1-.857-.86z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandmarkCluster);
export default __webpack_public_path__ + "static/media/landmark_cluster.74f0eeb3f6549e8d2e687d17616eab57.svg";
export { ForwardRef as ReactComponent };